/* tslint:disable */

/**
 * Options REST API
 *
 * Access market data, manage accounts, and trade Binance Options.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PlaceMultipleOrdersOrdersParameterInner
 */
export interface PlaceMultipleOrdersOrdersParameterInner {
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    symbol: string;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    side: PlaceMultipleOrdersOrdersParameterInnerSideEnum;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    type: PlaceMultipleOrdersOrdersParameterInnerTypeEnum;
    /**
     * Order Quantity
     * @type {number}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    quantity: number;
    /**
     * Order Price
     * @type {number}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    price?: number;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    timeInForce?: PlaceMultipleOrdersOrdersParameterInnerTimeInForceEnum;
    /**
     *
     * @type {boolean}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    reduceOnly?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    postOnly?: boolean;
    /**
     *
     * @type {string}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    newOrderRespType?: PlaceMultipleOrdersOrdersParameterInnerNewOrderRespTypeEnum;
    /**
     * User-defined order ID cannot be repeated in pending orders
     * @type {string}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    clientOrderId?: string;
    /**
     * is market maker protection order
     * @type {boolean}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    isMmp?: boolean;
    /**
     * EXPIRE_TAKER:expire taker order when STP triggers/ EXPIRE_MAKER:expire maker order when STP triggers/ EXPIRE_BOTH:expire both orders when STP triggers; Default EXPIRE_MAKER
     * @type {string}
     * @memberof PlaceMultipleOrdersOrdersParameterInner
     */
    selfTradePreventionMode?: PlaceMultipleOrdersOrdersParameterInnerSelfTradePreventionModeEnum;
}

export const PlaceMultipleOrdersOrdersParameterInnerSideEnum = {
    BUY: 'BUY',
    SELL: 'SELL',
} as const;

export type PlaceMultipleOrdersOrdersParameterInnerSideEnum =
    (typeof PlaceMultipleOrdersOrdersParameterInnerSideEnum)[keyof typeof PlaceMultipleOrdersOrdersParameterInnerSideEnum];
export const PlaceMultipleOrdersOrdersParameterInnerTypeEnum = {
    LIMIT: 'LIMIT',
} as const;

export type PlaceMultipleOrdersOrdersParameterInnerTypeEnum =
    (typeof PlaceMultipleOrdersOrdersParameterInnerTypeEnum)[keyof typeof PlaceMultipleOrdersOrdersParameterInnerTypeEnum];
export const PlaceMultipleOrdersOrdersParameterInnerTimeInForceEnum = {
    GTC: 'GTC',
    IOC: 'IOC',
    FOK: 'FOK',
    GTX: 'GTX',
} as const;

export type PlaceMultipleOrdersOrdersParameterInnerTimeInForceEnum =
    (typeof PlaceMultipleOrdersOrdersParameterInnerTimeInForceEnum)[keyof typeof PlaceMultipleOrdersOrdersParameterInnerTimeInForceEnum];
export const PlaceMultipleOrdersOrdersParameterInnerNewOrderRespTypeEnum = {
    ACK: 'ACK',
    RESULT: 'RESULT',
} as const;

export type PlaceMultipleOrdersOrdersParameterInnerNewOrderRespTypeEnum =
    (typeof PlaceMultipleOrdersOrdersParameterInnerNewOrderRespTypeEnum)[keyof typeof PlaceMultipleOrdersOrdersParameterInnerNewOrderRespTypeEnum];
export const PlaceMultipleOrdersOrdersParameterInnerSelfTradePreventionModeEnum = {
    EXPIRE_TAKER: 'EXPIRE_TAKER',
    EXPIRE_MAKER: 'EXPIRE_MAKER',
    EXPIRE_BOTH: 'EXPIRE_BOTH',
} as const;

export type PlaceMultipleOrdersOrdersParameterInnerSelfTradePreventionModeEnum =
    (typeof PlaceMultipleOrdersOrdersParameterInnerSelfTradePreventionModeEnum)[keyof typeof PlaceMultipleOrdersOrdersParameterInnerSelfTradePreventionModeEnum];
